<account-page>
	<vip-paginator
		[paginator]="ordersService.paginator"
		[requesting]="ordersService.loading"
		(pageChanged)="setPaginator($event)"
	></vip-paginator>
	<cdk-table-component
		[displayColumns]="displayColumns"
		[entities]="tableEntities"
		[dataSource]="dataSource"
		(rowClickAction)="viewOrder($event)"
	></cdk-table-component>
</account-page>
